export const INTERACTIVE_AUDIO_SCRUB_HIT_HEIGHT_PX = 24;

export const INTERACTIVE_AUDIO_WAVEFORM_BAR_COUNT = 48;

export const INTERACTIVE_AUDIO_MIN_BUFFER_SECONDS = 10;

export const INTERACTIVE_AUDIO_MIN_REVEAL_DURATION_MS = 1000;
